import find from 'lodash/find'
import { FieldOption } from './accountTypes'

const options: FieldOption[] = [
  { name: 'Open', value: 'open' },
  { name: 'Cancelled', value: 'cancelled' },
  { name: 'Pending Invoice', value: 'pending_invoice' },
  { name: 'Awaiting Payment', value: 'awaiting_payment' },
  { name: 'Partial Payment Received', value: 'partial_payment_received' },
  { name: 'Payment Received', value: 'payment_received' },
  { name: 'Payment Failed', value: 'payment_failed' },
  { name: 'Closed', value: 'closed' }
]

export function statusName (value: string): string {
  const option = find(options, { value })
  return option ? option.name : value
}

export default options
